/**
 * @property {SummaryItem[]} added
 * @property {SummaryItem[]} removed
 * @property {SummaryItem[]} changed
 */
export class Summary {
  constructor({ addedItems = [], removedItems = [], changedItems = [] }) {
    this.addedItems = addedItems;
    this.removedItems = removedItems;
    this.changedItems = changedItems;
  }

  isEmpty() {
    return (
      this.addedItems.length === 0 &&
      this.removedItems.length === 0 &&
      this.changedItems.length === 0
    );
  }
}
